/** get_albums storm tracker — split from libraryAlbumWallInvalidation (#916 size gate). */
import { diagnosticLog } from '../utils/diagnosticLogger';

export const GET_ALBUMS_STORM_PAGES_PER_MIN = 20;
export const GET_ALBUMS_FULL_PAGE_MIN_LIMIT = 200;

const STORM_WINDOW_MS = 60_000;
const STORM_BEACON_COOLDOWN_MS = 60_000;

let stormPageAt: number[] = [];
let lastStormBeaconAt = 0;
let stormTrigger = 'unknown';

/** Label the next get_albums pages (edit, scan-complete, catalog-changed, …). */
export function setGetAlbumsStormTrigger(trigger: string): void {
  stormTrigger = String(trigger || 'unknown');
}

export function getGetAlbumsStormTrigger(): string {
  return stormTrigger;
}

export function resetGetAlbumsStormTrackerForTests(): void {
  stormPageAt = [];
  lastStormBeaconAt = 0;
  stormTrigger = 'unknown';
}

export function getGetAlbumsStormCallsInWindowForTests(): number {
  const now = Date.now();
  return stormPageAt.filter((t) => now - t < STORM_WINDOW_MS).length;
}

/**
 * Count full-library get_albums pages (limit ≥ 200). Beacon get_albums_storm
 * when more than 20 such pages land in a rolling minute.
 */
export function noteGetAlbumsPage(args: {
  limit?: number;
  offset?: number;
  trigger?: string;
} = {}): void {
  const limit = Number(args.limit ?? 0);
  if (!Number.isFinite(limit) || limit < GET_ALBUMS_FULL_PAGE_MIN_LIMIT) return;
  const now = Date.now();
  const trigger = String(args.trigger || stormTrigger || 'unknown');
  stormPageAt.push(now);
  stormPageAt = stormPageAt.filter((t) => now - t < STORM_WINDOW_MS);
  const callsPerMin = stormPageAt.length;
  if (callsPerMin <= GET_ALBUMS_STORM_PAGES_PER_MIN) return;
  if (now - lastStormBeaconAt < STORM_BEACON_COOLDOWN_MS) return;
  lastStormBeaconAt = now;
  try {
    diagnosticLog('warn', 'js:render', 'get_albums_storm', {
      calls_per_min: callsPerMin,
      trigger,
      offset: Number(args.offset ?? 0),
      limit,
    });
  } catch {
    /* never throw from a beacon */
  }
}
